import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card"
}
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = { class: "card-title d-flex flex-column" }
const _hoisted_4 = { class: "mb-0" }
const _hoisted_5 = { class: "d-flex align-items-center mt-1" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-people-fill text-success me-2" }, null, -1)
const _hoisted_7 = { class: "fw-semibold text-success" }
const _hoisted_8 = { class: "me-4" }
const _hoisted_9 = { class: "col-md-12 col-sm-8 mb-3" }
const _hoisted_10 = { class: "form-label" }
const _hoisted_11 = ["placeholder"]
const _hoisted_12 = { class: "card-body pt-0" }
const _hoisted_13 = {
  key: 0,
  class: "badge badge-light-success"
}
const _hoisted_14 = {
  key: 1,
  class: "badge badge-light-danger"
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "svg-icon svg-icon-2x" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Datatable = _resolveComponent("Datatable")!

  return (_ctx.can('read', 'newsletter'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.translate('newsletterSubscribers')), 1),
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.totalAllSubscribers) + " " + _toDisplayString(_ctx.translate('subscribers')), 1)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.translate('email')), 1),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control form-control-lg form-control-solid",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
                  onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onSubmitFilter && _ctx.onSubmitFilter(...args)), ["enter"])),
                  placeholder: _ctx.translate('search')
                }, null, 40, _hoisted_11), [
                  [_vModelText, _ctx.email]
                ])
              ]),
              _createElementVNode("button", {
                class: "btn btn-sm btn-primary mt-2",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onSubmitFilter && _ctx.onSubmitFilter(...args)))
              }, _toDisplayString(_ctx.translate('apply')), 1),
              _createElementVNode("button", {
                class: "btn btn-sm btn-light me-1 mt-2",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onResetFilter && _ctx.onResetFilter(...args)))
              }, _toDisplayString(_ctx.translate('reset')), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_Datatable, {
            "table-data": _ctx.tableData,
            "table-header": _ctx.tableHeader,
            loading: _ctx.loading,
            "rows-per-page": 10,
            total: _ctx.totalAllSubscribers,
            "enable-items-per-page-dropdown": false,
            onCurrentChange: _ctx.pageChanged
          }, {
            "cell-id": _withCtx(({ row: subscriber }) => [
              _createTextVNode(_toDisplayString(subscriber.id), 1)
            ]),
            "cell-amount": _withCtx(({ row: subscriber }) => [
              _createTextVNode(_toDisplayString(subscriber.email), 1)
            ]),
            "cell-subscribed_at": _withCtx(({ row: subscriber }) => [
              _createTextVNode(_toDisplayString(_ctx.formatDate(subscriber.subscribed_at)), 1)
            ]),
            "cell-is_active": _withCtx(({ row: subscriber }) => [
              (subscriber.is_active)
                ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.translate('active')), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.translate('inactive')), 1))
            ]),
            "cell-actions": _withCtx(({ row: subscriber }) => [
              _createElementVNode("a", {
                href: "#",
                class: _normalizeClass(["btn btn-icon btn-bg-none btn-active-color-warning btn-sm", subscriber.is_active ? '' : 'disabled']),
                onClick: _withModifiers(($event: any) => (_ctx.toggleStatusUser(subscriber)), ["prevent"])
              }, [
                _createElementVNode("span", _hoisted_16, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen034.svg" })
                ])
              ], 10, _hoisted_15)
            ]),
            _: 1
          }, 8, ["table-data", "table-header", "loading", "total", "onCurrentChange"])
        ])
      ]))
    : _createCommentVNode("", true)
}